import React, { useEffect } from 'react';

import { Dialog, TextField } from '@material-ui/core';
import PropTypes from 'prop-types';

import LogoMemphis from '../../../../assets/images/memphis-logo.png';
import { ButtonPrimary } from '../../../../shared/components';
import { useGetMemphisCredentials } from '../../hooks/use-get-memphis-credentials';
import { useSetMemphisCredentials } from '../../hooks/use-set-memphis-credentials';
import { BootstrapDialogTitle } from '../BootstrapDialogTitle';
import { DivActions, ContentModal } from '../styles';

export function ModalMemphis({ open, handleClose, storeId }) {
  const { getMemphisCredentials, credentials, setCredentials } =
    useGetMemphisCredentials({ storeId });
  const { setMemphisCredentials } = useSetMemphisCredentials();

  useEffect(() => {
    if (open) {
      getMemphisCredentials(storeId);
    }
  }, [open]);

  return (
    <Dialog fullWidth={600} open={open} onClose={handleClose}>
      <BootstrapDialogTitle onClose={handleClose} logo={LogoMemphis}>
        Linkar conta com Memphis
      </BootstrapDialogTitle>
      {credentials && (
        <ContentModal>
          <TextField
            id="username"
            label="Usuário *"
            variant="outlined"
            fullWidth
            value={credentials.username}
            onChange={(e) =>
              setCredentials({
                ...credentials,
                username: e.target.value.trim(),
              })
            }
          />
          <TextField
            id="password"
            label="Senha *"
            variant="outlined"
            fullWidth
            value={credentials.password}
            onChange={(e) =>
              setCredentials({
                ...credentials,
                password: e.target.value.trim(),
              })
            }
          />
        </ContentModal>
      )}
      <DivActions>
        <ButtonPrimary.Normal
          width="100%"
          label="LINKAR CONTA"
          onClick={async () => {
            await setMemphisCredentials({ credentials, storeId });
            handleClose();
          }}
        />
      </DivActions>
    </Dialog>
  );
}

ModalMemphis.propTypes = {
  storeId: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};
